export const Locale = {
  French: "fr_FR",
  Chinese: "zh_CN",
  German: "de_DE",
  English: "en_GB",
  Japanese: "ja_JP",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Locale = typeof Locale[keyof typeof Locale];

export function getAllLocales(allowLocaleDebug: boolean = false) {
  const list = [
    {
      id: Locale.French,
      label: "Français",
      shorten: "fr",
    },
    {
      id: Locale.English,
      label: "English",
      shorten: "en",
    },
    {
      id: Locale.German,
      label: "Deutsch",
      shorten: "de",
    },
    {
      id: Locale.Chinese,
      label: "简体中文",
      shorten: "zh-cn",
    },
    {
      id: Locale.Japanese,
      label: "Japanese",
      shorten: "ja",
    },
  ] as { id: Locale; label: string; shorten: string }[];

  if (allowLocaleDebug) {
    list.push({
      //@ts-ignore
      id: "dev",
      label: "DEV",
      shorten: "DEV",
    });
  }
  return list;
}
